import { useState } from 'react';
import clsx from 'clsx';
import IconButton from 'components/icon-button';

import caretUp from 'assets/images/caret-up.svg';
import caretDown from 'assets/images/caret-down.svg';
import styles from './styles.module.scss';

type CollapseProps = {
  header: string;
  className?: string;
  children: React.ReactNode;
};

const Collapse: React.FC<CollapseProps> = (props) => {
  const { header, className, children } = props;

  const [open, setOpen] = useState(true);

  return (
    <div className={clsx(styles.container, className)}>
      <div className={styles.header}>
        {header}
        <IconButton
          iconWidth={24}
          iconHeight={24}
          className={styles.button}
          onClick={() => setOpen(!open)}
          icon={open ? caretUp : caretDown}
        />
      </div>
      {open && <div className={styles.content}>{children}</div>}
    </div>
  );
};

export default Collapse;
